import { lazy } from 'react';

const Tag = lazy(() => import('./Tag'));

export { Tag };
